(() => {
  const initializeTabs = (root = document) => {
    root.querySelectorAll('[data-mrp-product-tabs]').forEach((tabGroup) => {
      if (tabGroup.dataset.mrpTabsReady === 'true') return;

      const tabs = Array.from(tabGroup.querySelectorAll('[role="tab"]'));
      const panels = Array.from(tabGroup.querySelectorAll('[role="tabpanel"]'));

      const equalizePanels = () => {
        let tallestPanel = 0;

        panels.forEach((panel) => {
          const wasHidden = panel.hidden;
          const previousStyle = panel.getAttribute('style');

          panel.hidden = false;
          panel.style.position = 'absolute';
          panel.style.visibility = 'hidden';
          panel.style.width = '100%';
          panel.style.minHeight = '0';
          tallestPanel = Math.max(tallestPanel, panel.scrollHeight);

          if (previousStyle === null) panel.removeAttribute('style');
          else panel.setAttribute('style', previousStyle);
          panel.hidden = wasHidden;
        });

        if (tallestPanel > 0) {
          tabGroup.style.setProperty('--mrp-service-panel-height', `${Math.ceil(tallestPanel)}px`);
        }
      };

      const activate = (tab, moveFocus = false) => {
        const target = tab.dataset.mrpTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.mrpPanel !== target;
        });

        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });

      activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      equalizePanels();

      let resizeFrame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(equalizePanels);
      });

      if (document.fonts?.ready) document.fonts.ready.then(equalizePanels);
      tabGroup.dataset.mrpTabsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeTabs());
  } else {
    initializeTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initializeTabs(event.target));
})();
